import { useContext } from '@fipnooone/react-modal';
import { FC } from 'react';

import { Button } from '@/Components/UI/Button';
import { Icon } from '@/Components/UI/Icon';

interface ForbiddenProps {
    message?: string;
}

export const ModalForbidden: FC<ForbiddenProps> = ({ message = 'You do not have permission to do this' }) => {
    const modal = useContext();

    return (
        <div className="unsaved">
            <Icon name="close" size={20} onClick={() => modal.close()} />

            <h1>{message}</h1>

            <Button color="brown" text="Ok" onClick={() => modal.close()} />
        </div>
    );
};
